import {useEffect, useState} from 'react';
import useGoToNavigation from '../../util/useGotoNavigation';
import {useTranslation} from 'react-i18next';
import {LanguageDropdown} from '../common/LanguageDropdown';
import {useMutation} from "@tanstack/react-query";
import {resetPasswordApi} from "../../api/user/UserApi";
import {useModal} from "../../hooks";
import {useParams} from "react-router-dom";

export const PasswordReset3 = () => {
    const {id} = useParams()
    const {t} = useTranslation();
    const {handleModal} = useModal();

    const {goToNavigation} = useGoToNavigation();

    const [resetPwReq, setResetPwReq] = useState({
        userPw: "",
        userPwChk: "",
    });

    const [isValid, setisValid] = useState(true);
    const [isSame, setIsSame] = useState(true);

    const pwChangeApi = () => {
        if (resetPwReq.userPw === "" || resetPwReq.userPwChk === "") {
            setisValid(false)
            return;
        }

        if (resetPwReq.userPw !== resetPwReq.userPwChk) {
            setIsSame(false)
            return;
        }

        resetPasswordApiMutate.mutate()
    }

    const resetPasswordApiMutate = useMutation({
        mutationFn: () => resetPasswordApi({uuid: id, newPassword: resetPwReq.userPw}),
        onSuccess: res => {
            if (res.data.code === "0000") {
                console.log("hi")
                handleModal({
                    isOpen: true,
                    contents: "변경되었습니다.",
                    type: "alert",
                    closeAction: () => goToNavigation('login', {}, true)
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                })
            }
        },
    });

    useEffect(() => {
        if (!id) {
            handleModal({
                isOpen: true,
                contents: "올바르지 않은 접근입니다.",
                type: "alert",
                closeAction: () => goToNavigation('login', {}, true)
            })
        }
    }, [id]);

    useEffect(() => {
        setIsSame(true)
        setisValid(true)
    }, [resetPwReq])

    return (
        <>
            <div className="login_content">
                <div className="login_lang_outer">
                    <LanguageDropdown/>
                </div>
                <div className="login_box">
                    <img src={process.env.PUBLIC_URL + "/assets/images/login_logo.png"} alt=""/>
                    <p className="text_password_reset line1">
                        {t('pwReset3-resetpw-label')}
                    </p>
                    <p className="text_password_reset line2">
                        {t('pwReset3-resetpw-desc1')}
                    </p>
                    <div className="frm_login_row">
                        <div className="input-group">
                            <span className="input-group-text">
                                <img src={process.env.PUBLIC_URL + "/images/assets/icon_login_input2.png"} alt=""/>
                            </span>
                            <input type="password"
                                   className="form-control"
                                   value={resetPwReq.userPw}
                                   onChange={(e) => setResetPwReq({...resetPwReq, userPw: e.target.value})}
                                   placeholder={t('pwReset3-resetpw-input')}/>
                        </div>
                    </div>

                    <div className="frm_login_row mb-0">
                        <div className="input-group">
                            <span className="input-group-text">
                                <img src={process.env.PUBLIC_URL + "/images/assets/icon_login_input2.png"} alt=""/>
                            </span>
                            <input type="password"
                                   className="form-control"
                                   value={resetPwReq.userPwChk}
                                   onChange={(e) => setResetPwReq({...resetPwReq, userPwChk: e.target.value})}
                                   placeholder={t('pwReset3-resetpw-input2')}/>
                        </div>
                    </div>
                    {!isValid ?
                        <div className="error-messageLogin">{t('pwReset3-resetpw-validation')}</div>
                        :
                        !isSame ?
                            <div className="error-messageLogin">{t('pwReset3-resetpw-validation2')}</div>
                            : ""
                    }


                    <button className="btn btn-info btn-lg btn_login"
                            onClick={pwChangeApi}>{t('pwReset3-btn-label')}</button>
                </div>
            </div>
        </>
    );
}